module.exports = __webpack_public_path__ + "static/composition-test-bf6b6f03ea3255d8d6b9930f5f43ec30.jpg";